// src/constants/pricing.ts

export const PRICING = {
    INR: {
      monthly: {
        amount: 799,
        display: '₹799',
        currency: 'INR',
        period: 'month',
      },
      annual: {
        amount: 7999,
        display: '₹7,999',
        currency: 'INR',
        period: 'year',
        monthlyEquivalent: '₹666/month',
        savings: '₹1,589',
      },
      emergencyBoost: {
        amount: 149,
        display: '₹149',
        currency: 'INR',
        credits: 3,
      },
    },
    USD: {
      monthly: {
        amount: 999, // $9.99 in cents
        display: '$9.99',
        currency: 'USD',
        period: 'month',
      },
      annual: {
        amount: 9900, // $99 in cents
        display: '$99',
        currency: 'USD',
        period: 'year',
        monthlyEquivalent: '$8.25/month',
        savings: '$20.88',
      },
      emergencyBoost: {
        amount: 299, // $2.99 in cents
        display: '$2.99',
        currency: 'USD',
        credits: 3,
      },
    },
  }
  
  export const DODO_PRODUCT_IDS = {
    monthly: 'pdt_kcZumWYRsfYhVmvZDI1Vs',
    annual: 'pdt_wH30UduTUneptb9BXIonP',
    emergencyBoost: 'pdt_IHIDsAvqVzRux8jUgx5sf',

    //Test Products
    //monthly: 'pdt_FS1fo4Cm0AbTfrv31q9oB',
    //annual: 'pdt_sU3An1UTrWE8lPaIXsIeU',
    //emergencyBoost: 'pdt_V3FPpFPvT12ag4UFUKDSv',

    //LIVE Test Products
    //monthly: 'pdt_5rhYWfvskSzMkGblheIPK',
    //annual: 'pdt_5rhYWfvskSzMkGblheIPK',
    //emergencyBoost: 'pdt_5rhYWfvskSzMkGblheIPK',
  }